<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'agencias', params:{idBusiness: idBusiness}}">
                                {{$t("agencias")}}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t("agencia")}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier">
                                <i class="fa fa-building"></i> {{nombreNegocio}}
                            </h2>
                            <hr>
                        </div>
                        <div class="col-md-8">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="nameCasa"><strong>{{$t("nombreAgencia")}} <span>*</span> </strong></label>
                                        <input type="text" class="form-control"
                                               :class="{'is-valid': agencia.name.length >0 && agencia.name.length <= maxNameAgencia,
                                               'is-invalid': agencia.name.length > maxNameAgencia}"
                                               id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')" v-model="agencia.name"
                                               ref="name">
                                        <input type="hidden" v-model="agencia.xname">
                                        <small class="form-text text-muted">{{agencia.name.length}}/50</small>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="comision"><strong>{{$t("comision")}}</strong></label>
                                        <vue-numeric currency="%"
                                                     id="comision"
                                                     inputmode="decimal"
                                                     type="text"
                                                     class="form-control"
                                                     currency-symbol-position="suffix"
                                                     :precision="2"
                                                     v-model=agencia.comision
                                                     @keydown.native="$methods.evitarComasDecimales"
                                                     ></vue-numeric>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="descuento"><strong>{{$t("descuento")}}</strong></label>
                                        <vue-numeric currency="%"
                                                     id="descuento"
                                                     inputmode="decimal"
                                                     type="text"
                                                     class="form-control"
                                                     currency-symbol-position="suffix"
                                                     :precision="2"
                                                     v-model=agencia.dto
                                                     @keydown.native="$methods.evitarComasDecimales"
                                                     ></vue-numeric>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="tarifa"><strong>{{$t("tarifa")}}</strong></label>
                                        <select id="tarifa" class="form-control" v-model.number="agencia.tarifa">
                                            <option :value="1">{{$t("tarifa1")}}</option>
                                            <option :value="2">{{$t("tarifa2")}}</option>
                                            <option :value="3">{{$t("tarifa3")}}</option>
                                            <option :value="4">{{$t("tarifa4")}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label><strong>{{$t("colorBoton")}}</strong></label>
                                <div class="color-options">
                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="amarillo">
                                                <div class="colorWrap" style="background-color: #ffec9f"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="rojo">
                                                <div class="colorWrap" style="background-color: #ffbbbb"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="verde">
                                                <div class="colorWrap" style="background-color: #c1ffc1"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="morado">
                                                <div class="colorWrap" style="background-color: #ffbfff"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="blanco">
                                                <div class="colorWrap" style="background-color: #FFFFFF"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="azul">
                                                <div class="colorWrap" style="background-color: #cad3ff"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="naranja">
                                                <div class="colorWrap" style="background-color: #ffa54a"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="gris">
                                                <div class="colorWrap" style="background-color: #bbbbbb"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-4">
                                        <div class="radio">
                                            <label>
                                                <input v-model="agencia.color"
                                                       type="radio"
                                                       name="colors"
                                                       value="negro">
                                                <div class="colorWrap" style="background-color: #000000"></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <!-- baja -->
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("baja")}}</strong>
                                    </label>
                                    <el-switch v-model="agencia.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary"  v-once-click.once="saveAgencia" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>
                            <router-link :to="{name:'agencias', params:{idBusiness: idBusiness, 'pag' : pag}}">
                                <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{$t("cancelar")}}
                                </button>
                            </router-link>
                            <el-checkbox v-model="checkReply" border class="checkbox-element">
                                {{$t("replicar")}}
                            </el-checkbox>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal name="modalReply" :adaptive=true :scrollable=true height="auto"  :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("replicarAgencias")}}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
                           @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">{{$t("seleccionarTodos")}}</label>

                    <div v-for="business in listBusinesses">
                        <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border
                                     class="checkbox-element" style="width: 100%">
                            {{business.establishmentName}}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="closeModal()"><i
                            class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" @click="replyAgencias()"><i class="fa fa-check-circle"></i>
                        {{$t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import swal from 'sweetalert2'
    import {Checkbox, Switch} from 'element-ui'
    import {Loading} from 'element-ui';

    export default {
        props: ['idBusiness', 'idAgencia', 'pag'],
        created() {
            this.action = this.idAgencia ? this.$i18n.t("editar") : this.$i18n.t("nueva");
            this.loadingGeneral = Loading.service({text: this.$t("cargando")});

            this.identificacionNegocio();
            if (this.idAgencia) {
                this.getAgencia();
            }else{
                this.loadingGeneral.close();
            }
        },
        components: {
            [Checkbox.name]: Checkbox,
            [Switch.name]: Switch
        },
        mounted() {
            this.$refs.name.focus();
        },
        data() {
            return {

                agencia: {
                    xname: "",
                    name: "",
                    comision: 0,
                    dto: 0,
                    tarifa: 1,
                    baja: false,
                    color: "amarillo"
                },


                checkSelectAll: false,
                listBusinesses: [],
                checkReply: false,
                maxNameAgencia: 50,
                action: "",
                inProgress: false,
                nombreNegocio: ""
            }
        },
        methods: {
            identificacionNegocio() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/identifyBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.nombreNegocio = response.data.result

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            checkCampos() {
                if (this.agencia.name.length > this.maxNameOperario) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameOperario + '.',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type:  'error'
                    });
                    return false;
                } else if (this.agencia.name === null || this.agencia.name.length === 0) {
                    swal({
                        title:  this.$t('atencion'),
                        text:  this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    return true;
                }
            },
            getAgencia() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idAgencia: this.idAgencia,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'agencias/getAgenciaById', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.agencia = response.data.result;
                            vm.agencia.xname = response.data.result.name;
                            
                            vm.agencia.tarifa = (typeof vm.agencia.tarifa == 'undefined' || vm.agencia.tarifa == null || vm.agencia.tarifa == '') ? 1 : parseInt(vm.agencia.tarifa, 10);

                            vm.loadingGeneral.close();
                        } else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            saveAgencia() {
                if (this.checkCampos()) {
                    this.inProgress = true;

                    var config = {
                        params:{
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        agencia: this.agencia,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idAgencia ? "editAgenciaById" : "newAgenciaByBusiness";
                    this.axios.post(this.$store.getters.apiUrl + 'agencias/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.idAgencia ? vm.$t('actualizada') : vm.$t('creada');
                                vm.$notify({
                                    message: vm.$t('agencia') + notify + vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                if (vm.checkReply) {
                                    if (!vm.idAgencia) {
                                        vm.agencia.xname = vm.agencia.name;
                                    }
                                    vm.axios.get(vm.$store.getters.apiUrl + 'general/getBusinessesByUser', config)
                                        .then(function (response) {
                                            if (response.data.response) {
                                                vm.listBusinesses = response.data.result;
                                                vm.$modal.show('modalReply');
                                            } else {
                                                swal({
                                                    title: vm.$t('atencion'),
                                                    text: response.data.message,
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    type: 'error'
                                                });
                                            }

                                        });

                                } else {


                                    vm.$router.push({
                                        name: 'agencias',
                                        params: {idBusiness: vm.idBusiness, 'pag': vm.pag}
                                    })

                                }

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
                }
            },
            replyAgencias() {
                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                let xbusinesses = new Array();
                this.listBusinesses.forEach(function (business) {
                    if (business.checked && business.id!==vm.idBusiness) {
                        xbusinesses.push(business);
                    }
                });

                var params = {
                    listBusinesses: xbusinesses,
                    agencia: this.agencia,
                    jwt: this.$store.getters.jwt,
                    xname:this.xname,
                };


                this.axios.post(this.$store.getters.apiUrl + 'agencias/replyAgencia', params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                            vm.closeModal();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
            },
            closeModal() {
                this.$modal.hide('modalReply');
                this.$router.push({name: 'agencias', params: {idBusiness: this.idBusiness, 'pag': this.pag}})
            },
            selectAll() {
                if (this.checkSelectAll) {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = false;
                    });
                } else {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = true;
                    });
                }
            }
        }

    }
</script>

<style scoped>
    .card {
        padding: 20px;
    }

    .colorWrap {
        width: 50px;
        height: 50px;
        border: 1px solid #888;
        border-radius: 3px;
        display: block;
        margin: 0 auto 10px;
        cursor: pointer;
    }

    .color-options {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .color-options .col-md-2.col-4 {
        width: auto;
        flex: 0 0 auto;
        margin: 0 4px;
    }

    .color-options .col-md-2.col-4 {
        width: auto;
        flex: 0 0 auto;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Widgets/Agencias/AgenciasForm.vue